/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridColDef } from '@mui/x-data-grid-premium';
import { baseCell, textRenderCell } from 'components/cells';
import { dateFilterOperators, filterOperators } from 'components/enhanced/data-grid/utils';
import { useTranslation } from 'react-i18next';

export const useAggregatedColumns = (isTabView, lockWarehouseFilter): GridColDef[] => {
  const { t } = useTranslation();

  return [
    {
      field: 'equipment',
      headerName: t(`global.equipment`),
      width: 250,
      filterOperators,
      valueGetter: (params) => params.row.equipment_code,
      renderCell: baseCell
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      width: 300,
      filterOperators,
      renderCell: isTabView ? textRenderCell : baseCell
    },
    {
      field: 'serial_number',
      headerName: t(`entities.equipment.serial_number`),
      width: 200,
      filterOperators,
      renderCell: isTabView ? textRenderCell : baseCell
    },
    {
      field: 'warehouse_code',
      headerName: t(`global.warehouse`),
      width: 200,
      filterOperators,
      filterable: !lockWarehouseFilter,
      renderCell: baseCell
    },
    {
      field: 'position',
      headerName: t(`entities.equipment.position`),
      width: 200,
      filterOperators,
      renderCell: isTabView ? textRenderCell : baseCell
    },
    {
      field: 'supplier',
      headerName: t(`global.supplier`),
      width: 200,
      filterOperators,
      renderCell: isTabView ? textRenderCell : baseCell
    },
    {
      field: 'expected_month',
      headerName: t(`entities.equipment.expected_month`),
      width: 200,
      filterOperators: dateFilterOperators,
      renderCell: (params) => {
        const dateStr = params.value;
        if (!dateStr) return '';

        // Gestione formato ISO: 'yyyy-mm-dd'
        const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
        if (isoMatch) {
          const [, year, month] = isoMatch;
          return `${month}/${year}`;
        }

        // Altrimenti, fallback su 'dd/mm/yyyy'
        const parts = dateStr.split('/');
        if (parts.length === 3) {
          const month = parts[1];
          const year = parts[2];
          return `${month}/${year}`;
        }

        // Fallback: ritorna stringa originale
        return dateStr;
      }
    }
  ];
};
